import {EntityService} from '../../../../service/EntityService';

export class UserService extends EntityService {

  static entity = 'api/app/tenant-user';

  static currentTenant(): Promise<any>{
    return this.axios.get(`${this.entity}/current`).then(res => res.data);
  }
}
